import { render, staticRenderFns } from "./ChoiceButton.vue?vue&type=template&id=dfd66354&"
import script from "./ChoiceButton.vue?vue&type=script&lang=js&"
export * from "./ChoiceButton.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports